import dayjs from "dayjs";
import { useCatalogState } from "@/hooks/useCatalogState";
import { useCheckoutFormState } from "@/hooks/useCheckoutFormState";
import { useStorefrontSettingsState } from "@/hooks/useStorefrontSettingsState";
import { useTranslate } from "@/hooks/useTranslate/useTranslate";
import { DateTimeRangePicker } from "../ui-custom/date-time-range-picker";

export type CheckoutDateProps = {
	fullwidth?: boolean;
	catalogId?: string;
	className?: string;
	required?: boolean;
};
export const ReservationDates: React.FC<CheckoutDateProps> = (props) => {
	const checkoutFormState = useCheckoutFormState();
	const catalogState = useCatalogState();
	const storefrontSettingsState = useStorefrontSettingsState();
	const isFormDisabled = checkoutFormState.isFormDisabled();
	const translate = useTranslate();
	const storefrontSettings = storefrontSettingsState.get().settings;
	const isUniversity = storefrontSettings?.IsUniversity ?? false;
	const separateQuoteRequestsByCatalog =
		storefrontSettings?.SeparateQuoteRequestsByCatalog ?? false;
	let fromDate = checkoutFormState.get().fromDateValue;
	let fromTime = checkoutFormState.get().fromTimeValue;
	let toDate = checkoutFormState.get().toDateValue;
	let toTime = checkoutFormState.get().toTimeValue;
	if (props.catalogId) {
		fromDate = checkoutFormState.getFromDate(props.catalogId);
		fromTime = checkoutFormState.getFromTime(props.catalogId);
		toDate = checkoutFormState.getToDate(props.catalogId);
		toTime = checkoutFormState.getToTime(props.catalogId);
	}
	const fromDateObj = fromDate
		? dayjs(fromDate, "YYYY-MM-DD").toDate()
		: undefined;
	const toDateObj = toDate ? dayjs(toDate, "YYYY-MM-DD").toDate() : undefined;
	const label = translate("Reservation Dates");
	const activeCatalog = props.catalogId
		? catalogState.getCatalogById(props.catalogId)
		: undefined;
	const shouldEnforceCatalogRequestHours =
		isUniversity && separateQuoteRequestsByCatalog && !!props.catalogId;
	return (
		<DateTimeRangePicker
			required={props.required}
			className={`w-full ${props.className || ""}`}
			disabled={isFormDisabled}
			disablePast
			label={label}
			infoText={translate(
				"Reservations for different date ranges must be submitted as separate Orders",
			)}
			value={{
				dateRange: {
					from: fromDateObj,
					to: toDateObj,
				},
				timeRange: {
					from: fromTime,
					to: toTime,
				},
			}}
			fromLabel={translate("From")}
			toLabel={translate("To")}
			catalogDurationRules={
				shouldEnforceCatalogRequestHours
					? {
							minHours: activeCatalog?.MinEquipmentRequestHours,
							maxHours: activeCatalog?.MaxEquipmentRequestHours,
						}
					: undefined
			}
			onChange={async (value) => {
				return Promise.resolve().then(() => {
					let fromDate = "";
					let fromTime = "";
					if (value?.dateRange?.from) {
						fromDate = dayjs(value?.dateRange?.from).format("YYYY-MM-DD");
						fromTime = value?.timeRange?.from || "";
					}
					checkoutFormState.setFromDate(fromDate, props.catalogId);
					checkoutFormState.setFromTime(fromTime, props.catalogId);
					let toDate = "";
					let toTime = "";
					if (value?.dateRange?.to) {
						toDate = dayjs(value?.dateRange?.to).format("YYYY-MM-DD");
						toTime = value?.timeRange?.to || "";
					}
					checkoutFormState.setToDate(toDate, props.catalogId);
					checkoutFormState.setToTime(toTime, props.catalogId);
				});
			}}
		/>
	);
};
